import { Field, FormSpy } from 'react-final-form';
import { Button } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import FieldGroup from '../../FieldGroup.jsx';
import ParentGroupSelect from './GroupsFormFields/ParentGroupSelect.jsx';

const GroupItem = (props) => {
  const {
    group,
    index,
    padding,
    editableId,
    groupsTree,
    groupsFlattened,
    setEditableId,
    onSaveChanges,
    onRemoveNode,
    manuallyFieldError,
    isActionDisabled,
    onAddNode,
    setManuallyFieldError,
  } = props;
  const { id, children, parentId } = group;

  const [fieldsState, setFieldsState] = useState({
    name: group.name || '',
    email: group.email || '',
    parentId: group.parentId || null,
  });

  const parentGroup =
    fieldsState.parentId &&
    groupsFlattened.find((g) => g.id === fieldsState.parentId);
  const groupsFieldTitle = parentGroup ? parentGroup.name : null;

  useEffect(() => {
    setManuallyFieldError({});
  }, [fieldsState]);

  return (
    <div style={{ paddingLeft: padding ? '30px' : '0' }}>
      <div className="flex flex-align-start">
        <h3
          className="text-muted m-t-36"
          style={{ opacity: !parentId ? 1 : 0 }}
        >
          {index + 1}
        </h3>

        <div className="m-l-16" style={{ minWidth: '270px' }}>
          <FormSpy subscription={{ errors: true }}>
            {({ errors }) => (
              <Field
                id={`name${id}`}
                name={`name${id}`}
                label="Group"
                type="text"
                placeholder="Group"
                disabled={editableId !== id}
              >
                {(props) => (
                  <FieldGroup
                    {...props}
                    value={fieldsState.name}
                    onChange={(e) =>
                      setFieldsState({ ...fieldsState, name: e.target.value })
                    }
                    validateWithoutTouched={errors.hasOwnProperty(`name${id}`)}
                    manuallyGeneratedError={manuallyFieldError[`name${id}`]}
                  />
                )}
              </Field>
            )}
          </FormSpy>
        </div>
        <div className="m-l-8" style={{ minWidth: '270px' }}>
          <FormSpy subscription={{ errors: true }}>
            {({ errors }) => (
              <Field
                id={`email${id}`}
                name={`email${id}`}
                label="Email"
                type="email"
                placeholder="Email"
                disabled={editableId !== id}
              >
                {(props) => (
                  <FieldGroup
                    {...props}
                    value={fieldsState.email}
                    onChange={(e) =>
                      setFieldsState({ ...fieldsState, email: e.target.value })
                    }
                    validateWithoutTouched={errors.hasOwnProperty(`email${id}`)}
                    manuallyGeneratedError={manuallyFieldError[`email${id}`]}
                  />
                )}
              </Field>
            )}
          </FormSpy>
        </div>
        <div className="m-l-8" style={{ minWidth: '270px' }}>
          <ParentGroupSelect
            groups={groupsTree}
            groupId={group.id}
            parentId={fieldsState.parentId}
            groupsFieldTitle={groupsFieldTitle}
            handleSelect={(val) =>
              setFieldsState({ ...fieldsState, parentId: val })
            }
            disabled={editableId !== id}
          />
        </div>

        <div className="flex m-t-28">
          {editableId !== id ? (
            <Button
              className="btn-edit m-l-8"
              disabled={isActionDisabled}
              onClick={() => setEditableId(id)}
            >
              Edit
            </Button>
          ) : (
            <Button
              className="btn-check btn btn-success m-l-8"
              onClick={() => onSaveChanges(id, group, fieldsState)}
            >
              Edit
            </Button>
          )}

          <Button
            className="btn-add m-l-8"
            onClick={() => onAddNode(id)}
            disabled={isActionDisabled}
          >
            Add
          </Button>

          <Button
            className="btn-delete m-l-8"
            onClick={() => onRemoveNode(id)}
            disabled={isActionDisabled && editableId !== id}
          >
            Delete
          </Button>
        </div>
      </div>
      {children.length > 0 &&
        children.map((group, index) => (
          <React.Fragment key={group.id}>
            <GroupItem
              group={group}
              index={index}
              padding
              editableId={editableId}
              setEditableId={setEditableId}
              groupsTree={groupsTree}
              groupsFlattened={groupsFlattened}
              onSaveChanges={onSaveChanges}
              onAddNode={onAddNode}
              onRemoveNode={onRemoveNode}
              manuallyFieldError={manuallyFieldError}
              setManuallyFieldError={setManuallyFieldError}
              isActionDisabled={isActionDisabled}
            />
          </React.Fragment>
        ))}
      {!parentId && index + 1 !== groupsTree.length && (
        <hr style={{ marginTop: '2px' }} />
      )}
    </div>
  );
};

export default GroupItem;
